import React from 'react';
import { Link } from 'react-router-dom';
import Meta from './common/meta';
import GetInTouch from './common/getInTouch';
import projectData from '../data/projectData';

class Main extends React.Component {
    render() {
        const projects = projectData.project || [];

        return (
            <main className="app-index">
                <Meta />
                <section className="bg-light py-4 border-bottom mb-4">
                    <div className="container text-center">
                        <h1 className="h2 font-weight-bold text-dark mb-2">
                            Featured Software &amp; Web Engineering Projects
                        </h1>
                        <p className="lead text-muted mx-auto" style={{ maxWidth: '750px' }}>
                            A portfolio showcase of web applications, mobile apps, e-commerce solutions, and software systems engineered by <strong>Amanur Rahman</strong>.
                        </p>
                    </div>
                </section>

                <div className="container">
                    <div className="row">
                        {projects.map((block, key) => {
                            const projectLink = `/project/${block.url}`;
                            const imgPath = `/image/portfolio/${block.url}/${block.featuredImage}`;

                            return (
                                <div key={key} className="col-sm-6 col-lg-4 mb-4 d-flex align-items-stretch">
                                    <article className="card shadow-sm border-0 w-100 rounded-lg overflow-hidden item-grid-card">
                                        <div className="image position-relative overflow-hidden bg-light" style={{ height: '230px' }}>
                                            <img 
                                                src={imgPath} 
                                                alt={`${block.name} featured preview`} 
                                                className="card-img-top img-fluid project-card-img"
                                                loading="lazy"
                                                width="975"
                                                height="800"
                                                style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                                            />
                                            <div className="hover-view d-flex align-items-center justify-content-center">
                                                <div className="hover-actions-container d-flex align-items-center justify-content-center">
                                                    <Link 
                                                        className="btn btn-hover-action btn-hover-main rounded-pill px-3 py-2 text-nowrap font-weight-bold shadow mr-2"
                                                        to={projectLink}
                                                        aria-label={`View case study for ${block.name}`}
                                                    >
                                                        <i className="fa fa-link mr-1" aria-hidden="true"></i> View Project
                                                    </Link>
                                                    <a 
                                                        className="btn btn-hover-action btn-hover-sec rounded-pill px-3 py-2 text-nowrap font-weight-bold shadow" 
                                                        href={imgPath} 
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        aria-label={`View full image preview of ${block.name}`}
                                                    >
                                                        <i className="fa fa-eye mr-1" aria-hidden="true"></i> Zoom
                                                    </a>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card-body d-flex flex-column p-4">
                                            {block.category && (
                                                <div className="mb-2">
                                                    <span className="badge badge-primary px-2 py-1 font-weight-normal">{block.category}</span>
                                                </div>
                                            )}
                                            <h2 className="h5 card-title font-weight-bold mb-2">
                                                <Link to={projectLink} className="text-dark hover-primary text-decoration-none">
                                                    {block.name}
                                                </Link>
                                            </h2>
                                            <p className="card-text text-muted small mb-3 flex-grow-1">
                                                {block.desc}
                                            </p>
                                            {block.technologies && block.technologies.length > 0 && (
                                                <div className="mb-3 d-flex flex-wrap gap-1">
                                                    {block.technologies.map((tech, tIdx) => (
                                                        <span key={tIdx} className="badge badge-light border text-secondary mr-1 mb-1" style={{ fontSize: '0.75rem' }}>
                                                            {tech}
                                                        </span>
                                                    ))}
                                                </div>
                                            )}
                                            <div className="pt-2 border-top d-flex justify-content-between align-items-center">
                                                <Link 
                                                    to={projectLink}
                                                    className="font-weight-bold text-primary text-decoration-none small"
                                                >
                                                    Read Case Study &rarr;
                                                </Link>
                                                {block.website && (
                                                    <a 
                                                        href={block.website} 
                                                        target="_blank" 
                                                        rel="nofollow noopener noreferrer"
                                                        className="text-muted small"
                                                        title="Visit Live Website"
                                                    >
                                                        <i className="fa fa-external-link-alt" aria-hidden="true"></i> Live Link
                                                    </a>
                                                )}
                                            </div>
                                        </div>
                                    </article>
                                </div>
                            );
                        })}
                    </div>
                </div>

                <GetInTouch />
            </main>
        );
    }
}

export default Main;
